module.exports = __webpack_public_path__ + "img/SKMJ_crain6.bda574f5.jpg";